import React from "react"; 
 import { useTheme } from "@emotion/react";
 import envSetting from "../../configs/_setting";


const ThemeLogo = (props) => {
      const theme = useTheme();
      return (
            theme.palette.mode === 'dark'
                  ? <img src={envSetting.logo} height={props.size} alt="logo1" onClick={() => props.onClick} />
                  : <img src={envSetting.logo} height={props.size} alt="logo2" onClick={() => props.onClick} />
      )
};

export default ThemeLogo;
